/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {SettingsSection} from '@app/components/modals/shared/SettingsSection';
import {AnimationTabContent} from '@app/components/modals/tabs/accessibility_tab/AnimationTab';
import styles from '@app/components/modals/tabs/accessibility_tab/Inline.module.css';
import {KeyboardTabContent} from '@app/components/modals/tabs/accessibility_tab/KeyboardTab';
import {MotionTabContent} from '@app/components/modals/tabs/accessibility_tab/MotionTab';
import {VisualTabContent} from '@app/components/modals/tabs/accessibility_tab/VisualTab';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

export const AccessibilityInlineContent: React.FC = observer(() => {
	const {t} = useLingui();
	return (
		<div className={styles.container}>
			<SettingsSection id="visual" title={t`Visual`}>
				<VisualTabContent />
			</SettingsSection>
			<SettingsSection id="keyboard" title={t`Keyboard`}>
				<KeyboardTabContent />
			</SettingsSection>
			<SettingsSection id="animation" title={t`Animation`}>
				<AnimationTabContent />
			</SettingsSection>
			<SettingsSection id="motion" title={t`Motion`}>
				<MotionTabContent />
			</SettingsSection>
		</div>
	);
});
